export default "__VITE_ASSET__Bj3gIKo7__"